import Vue from 'vue'
import Router from 'vue-router'
import store from "./store.js";
import loginAPI from '@/api/LoginAPI.js'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue'),
      // beforeEnter: isLoggedIn
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/ResetPassword.vue'),
      // beforeEnter: requireAuth
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Dashboard.vue'),
      beforeEnter: requireAuth
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
      beforeEnter: requireAuth
    },
    {
      path: '/changePassword/:recID',
      name: 'changePassword',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/ChangePassword.vue'),
    },
    {
      path: '/orderRequest/',
      name: 'orderRequest',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/OrderRequest.vue'),
      beforeEnter: requireAuth
    },  
    {
      path: '/cart/',
      name: 'cart',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Cart.vue'),
      beforeEnter: requireAuth
    },  
    {
      path: '/thankYou/',
      name: 'thankYou',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/ThankYou.vue'),
      beforeEnter: requireAuth
    },  
    {
      path: '/userInfo/:recID',
      name: 'userInfo',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/UserInfo.vue'),
      beforeEnter: requireAuth
    }, 
    {
      path: '/orderDetail/:id',
      name: 'orderDetail',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/OrderDetail.vue'),
      beforeEnter: requireAuth
    },    
    {
      path: '/logout',
      name: 'logout',
      beforeEnter(to, from, next) {
        loginAPI.logout();
        next('/');
      }
    },
    {
      path: '/paymentForm/:id',
      name: 'paymentForm',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/PaymentForm.vue')
    },
    {
      path: '/paymentFormCustomer/:id',
      name: 'paymentFormCustomer',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/PaymentFormCustomer.vue')
    },
    {
      path: '/paymentSuccess',
      name: 'paymentSuccess',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/PaymentSuccess.vue')
    }
  ]
})
  // function isLoggedIn (to, from, next) {
  //   if (loginAPI.loggedIn()) {
  //     next({
  //       path: '/dashboard',
  //       query: { redirect: to.fullPath }
  //     })
  //   } 
  // }
  function requireAuth(to, from, next) {
    if (!loginAPI.loggedIn()) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } 
    else if(!loginAPI.passwordUpdated()){
      var recID = store.state.userInfo.recID
      next({
        path: '/changePassword/' + recID,
        // query: { redirect: to.fullPath }
      })
    }
    else {
        next()
    }
}
